import styled from "styled-components";

export default styled.iframe`
  width: 100%;
  height: 500px;
  background-color: #fff;
`;
